export default __webpack_public_path__ + "static/media/logo-mini.f5e49a18.png";